// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://opnawbebzrjsaeoeqgkd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9wbmF3YmVienJqc2Flb2VxZ2tkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyMzI5OTMsImV4cCI6MjA1MjgwODk5M30.3LjmEGPLb4DvkZPH-Mj-zCkQvNpo8PBWelHX37AMPCA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);